// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__m88mc {
  display: flex;
  align-items: center;
  gap: 12px;
}

.styles_label__I0LX- {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-align: left;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
}

.styles_description__zS2q3 {
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-align: left;
  text-transform: capitalize;
  color: #b6b6b6;
}`, "",{"version":3,"sources":["webpack://./src/pages/Exchange/pageContent/inputBlock/inputCurrency/modal/listItem/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BCPS;ADMX;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cCES;ADHX","sourcesContent":["@import '../../../../../../../assets/styles/variables/colors';\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.label {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-align: left;\n  text-transform: capitalize;\n  color: $white-80;\n}\n\n.description {\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-align: left;\n  text-transform: capitalize;\n  color: $grey-nav;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__m88mc`,
	"label": `styles_label__I0LX-`,
	"description": `styles_description__zS2q3`
};
export default ___CSS_LOADER_EXPORT___;
